import useLocalStorageState from "use-local-storage-state";
import { z } from "zod";

export function createLocalStorageDef<T extends z.ZodTypeAny>(name: string, schema: T) {
  return {
    get: (): z.infer<T> | null => {
      const value = localStorage.getItem(name);
      if (!value) {
        return null;
      }
      const parsed = schema.safeParse(JSON.parse(value));
      if (!parsed.success) {
        return null;
      }
      return parsed.data;
    },
    set: (value: z.input<T>) => {
      localStorage.setItem(name, JSON.stringify(schema.parse(value)));
    },
    remove: () => {
      localStorage.removeItem(name);
    },
    use: (p?: { defaultValue?: z.input<T> }) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return useLocalStorageState(name, {
        defaultValue: p?.defaultValue,
        serializer: {
          stringify: (value) => JSON.stringify(schema.parse(value)),
          parse: (value) => schema.parse(JSON.parse(value)),
        },
      });
    },
  };
}
